import ServicesHero from './components/ServicesHero';
import TrainingPrograms from './components/TrainingPrograms';
import CertificateGallery from './components/CertificateGallery';
import TrainingGallery from './components/TrainingGallery';
import RetainerBenefits from './components/RetainerBenefits';
import CaseStudies from './components/CaseStudies';
import Testimonials from './components/Testimonials';
import ConsultationForm from './components/ConsultationForm';
import ServicesCTA from './components/ServicesCTA';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';

export default function Services() {
  return (
    <div className="min-h-screen bg-black">
      <Navigation />
      <ServicesHero />
      <TrainingPrograms />
      <CertificateGallery />
      <TrainingGallery />
      <RetainerBenefits />
      <CaseStudies />
      <Testimonials />
      <ConsultationForm />
      <ServicesCTA />
      <Footer />
    </div>
  );
}
